import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    alignItems: 'center',
  },
  headerHeading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: ['xl', null, '2xl'],
    textShadow: '0px 2px 4px #00000040',
  },
  headerIconButton: {
    color: 'alpha.600',
    px: '1',
    size: '2xs',
    boxSize: '6',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },

    sx: {
      svg: { pos: 'relative', top: '0.5' },
    },
  },
  countdown: {
    sx: {
      py: 0,
      fontFamily: 'Roboto',
      fontWeight: '700',
      textShadow: 'none',

      '&&&.state-inprogress': {
        color: '#644915',
      },

      '&&&.state-prior': {
        bg: 'black',
        borderRadius: '3px',
        textTransform: 'uppercase',
        lineHeight: 'initial',
      },
    },
  },
  headerSkeletonText: {},
  headerVsBox: {
    color: 'alpha.500',
  },
  bodyStack: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: ['2', null, null, '4'],
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    color: 'alpha.500',
    h: '1.25em',
    ml: '1',
    w: 'auto',
  },
  sgmLogoV2: {
    color: 'black',
    w: '8',
    h: 'auto',
  },

  wrapperScrollSgm: { w: '100%', maxW: '100%', gap: '2' },
  scrollButtonGroup: {
    variant: 'filter',
  },
  scrollButtonGroupV2: {
    variant: 'unstyled',
    flex: 1,
    position: 'relative',
    minH: '34px',
  },
  toMarketButton: {
    borderColor: 'alpha.500',

    sx: {
      '&[data-active]': {
        borderWidth: '1px',
        bg: 'alpha.500',
        color: 'black',
      },
    },

    _last: { mr: 2 },
  },
  toMarketButtonV2: {
    color: 'white',
    fontSize: 'sm',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontFamily: 'CrimsonPro',
    fontWeight: 'bold',
    cursor: 'pointer',

    sx: {
      '&&': {
        px: 2,
        ml: 0,
      },
      '&[data-active]': {
        color: 'alpha.500',
        textShadow: '0px 0px 8px rgba(249, 182, 53, 0.5)',
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },

    _last: { mr: 20 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    bgGradient: 'linear(225deg, beta.200, beta.300)',
    border: '0',
    borderRadius: 'base',
    boxShadow:
      '0 3px 5px rgba(0, 0, 0, .2), 0 1px rgba(255, 255, 255, .15) inset',
    overflow: 'hidden',
  },
  accordionItemActive: {
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  },
  accordionButton: {
    fontSize: 'xs',
    fontWeight: 'bold',
    p: '2',
    pos: 'relative',
    textAlign: 'left',
    _after: {
      borderBottomWidth: '1px',
      borderColor: 'blackAlpha.400',
      bottom: '0',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      left: '0',
      opacity: '0',
      pos: 'absolute',
      right: '0',
      transition: 'inherit',
      zIndex: '1',
    },
    _expanded: {
      color: '#d6a64a',
      bg: 'rgba(255, 255, 255, 0.1)',
      textShadow: '0px 1px 4px rgba(0, 0, 0, 0.45)',
      _after: { opacity: '1' },
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'alpha.600',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'alpha.600',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    bg: 'beta.300',
    p: '0',
  },
  sgmBtn: {
    sx: {
      svg: {
        color: 'black',
        fill: 'black',
      },
    },
  },
  sgmBtnActive: {
    boxShadow: '0px 2px 4px 0px #00000040 inset, 0px 1px 0px 0px #FFFFFF1A',

    sx: {
      svg: {
        color: 'alpha.500',
        fill: 'alpha.500',
      },

      '&&': { bg: 'blackAlpha.500' },
    },

    _after: { display: 'none' },
  },
  cancelButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    px: '3',
  },
  clearButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    ml: '3',
    px: '3',
  },
};
